// TV Time's data is permanently deleted on 2026-07-15. Any refugee-facing copy that
// references the deadline has to flip to past-tense-safe wording after it passes —
// otherwise every landing/import surface reads wrong right in the middle of the
// migration window (which runs for weeks as people keep searching). Flip a bit AFTER
// the 15th (July 16, 12:00 UTC ≈ morning of the 16th across the US) so we never say
// "gone" while it's still the 15th somewhere. Evaluated at call time, not module load,
// so a long-lived session that crosses the boundary flips on its next render.
export const tvtimeGone = () => {
  try { return Date.now() >= Date.UTC(2026, 6, 16, 12) } catch { return false }
}
